import { useCallback } from 'react';

import { ITranslateMethod } from '@core/js/hooks/i18n/types';

import { useDynamicTagList } from '@interlayer/js/app/hooks/useDynamicTagList';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';

export const useCheckZips = (t: ITranslateMethod) => {
    const blockedZips = useDynamicTagList({
        tagName: DYNAMIC_TAG_NAMES.blockedZips,
        defaultValue: 'BT, GY, JE, IM'
    });

    return useCallback((value = '') => {
        const zip = value
            .trim()
            .slice(0, 2)
            .toLowerCase();

        if (blockedZips.some((item: string) => item === zip)) {
            return [t('zip.blocked')];
        }
    }, [blockedZips, t]);
};
